<script>
	// export let height = 'currentHeight';
</script>

<svg
	data-svg-carbon-icon="CicsSystemGroup32"
	xmlns="http://www.w3.org/2000/svg"
	fill="currentColor"
	viewBox="0 0 32 32"
	><path
		d="M28 2h-5v2h5v24h-5v2h5a2.0059 2.0059 0 0 0 2-2V4a2.0059 2.0059 0 0 0-2-2zM14 17H8a.9448.9448 0 0 0-1 1v6a.9448.9448 0 0 0 1 1h6a.9448.9448 0 0 0 1-1v-6a.9448.9448 0 0 0-1-1zm-1 6H9v-4h4z"
	/><path
		d="M25 24v-6a.9448.9448 0 0 0-1-1h-6a.9448.9448 0 0 0-1 1v6a.9448.9448 0 0 0 1 1h6a1.0021 1.0021 0 0 0 1-1zm-2-1h-4v-4h4zM14 7H8a.9448.9448 0 0 0-1 1v6a.9448.9448 0 0 0 1 1h6a.9448.9448 0 0 0 1-1V8a.9448.9448 0 0 0-1-1zm-1 6H9V9h4zm5 2h6a.9448.9448 0 0 0 1-1V8a.9448.9448 0 0 0-1-1h-6a.9448.9448 0 0 0-1 1v6a1.0021 1.0021 0 0 0 1 1zm1-6h4v4h-4z"
	/><path d="M4 4h5V2H4a2.0059 2.0059 0 0 0-2 2v24a2.0059 2.0059 0 0 0 2 2h5v-2H4Z" /></svg
>
